/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Početak',
	homePageTabsLabel: 'Početni sadržaj',
	myContent: 'Moj sadržaj',
	teamContent: 'Timski sadržaj',
	folder: 'Folder',
	files: 'Datoteke',
	actionMenu: 'Izbornik akcija',
	myFolder: 'Moji folderi',

	emptyFolderNoContent: 'Nema sadržaja',

	//EmptyStates
	emptyRecentTitle: 'Nedavno niste gledali sadržaj.',
	emptyStateTitle: 'Započnite s dodavanjem podataka',
	emptyStateBody: 'Kliknite gore Upload podataka ili podatke povucite i ispustite.',
	emptySearchResultTitle: 'Hm, vaše pretraživanje nije vratilo nijedan rezultat.',
	emptyPortalTitle: 'Nema portala',
	emptyPortalBody: 'Trenutno nemate nijedan portal.',
	emptyWsProjectTitle: 'Započnite s kreiranje bilježnice u Watson Studiu.',
	emptyWsProjectBody: 'Kad se vratite u Cognos Analytics, vaša bilježnica pojavit će se ovdje.',
	emptyFilteredResultTitle: 'Hmm, primijenjeni filteri nisu vratili nijedan rezultat.',
	emptyDialogViewTitle: 'Nema stavki',
	removeFromRecents: 'Ukloni iz nedavnog',

	// Welcome Banner
	welcomeBannerGreeting: 'Pozdrav. Dobro došli u Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson korisnicima pruža snagu samoposlužne analitike upravljane umjetnom inteligencijom. Pogledajte kako automatizirana priprema podataka, otkrivanje podataka i vizualizacije mogu potaknuti pouzdanije odluke.',
	welcomeBannerDescription_trialUser: 'Možete započeti odmah s našim uvodnim video prikazom, razgledavanjem proizvoda i karticom Kako započeti.',
	takeTourButtonLabel: 'Razgledajte proizvod',
	watchVideoButtonLabel: 'Pogledajte video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Jeste li sigurni da želite isključiti uvodnik dobrodošlice na početnoj stranici? Možete ga ponovno uključiti na kartici Profil i postavke > Postavke > Opće kad god želite. ',
	hideWelcomeBannerTitle: 'Isključi uvodnik dobrodošlice',
	ok: 'OK',
	cancel: 'Opoziv',
	warn: 'Upozorenje',
	//howto video dialog
	modal_how_title: 'Promatranje Cognos Analytics pregleda',
	modal_overview_title: 'Pogledajte Cognos Analytics pregled',
	modal_how_play: 'Izvedi video',
	modal_how_video_title_overview: 'Pregled',
	modal_how_video_title_getStarted: 'Kako započeti u 11.2',
	modal_how_video_title_newUI: 'Dobro došli u novi Cognos prikaz',
	modal_how_video_title_dataModule: 'Pregled modula podataka',
	modal_how_video_title_explore: 'Pregled istraživanja podataka',
	modal_how_video_title_dashboard: 'Pregled interaktivnih kontrolnih ploča',
	modal_how_video_title_reporting: 'Pregled izvještavanja',
	modal_how_video_title_mobile: 'Snaga Cognosa na dlanu',

	// Toolbar
	search: 'Traži',
	addFolder: 'Dodaj folder',
	addLink: 'Dodaj vezu',
	filter: 'Filter',
	sort: 'Sortiraj',
	settings: 'Postavke',
	tilesView: 'Pogled supodručja',
	listView: 'Pogled liste',
	columnView: 'Pogled stupca',
	backToSearch: 'Natrag na rezultate pretraživanja',

	// Toolbar Actions
	sortBy: 'Sortiraj po',
	sortOrder: 'Poredaj',
	name: 'Naziv',
	modifiedTime: 'Promijenjeno',
	type: 'Tip',
	ascending: 'Uzlazno',
	descending: 'Silazno',
	resetSort: 'Resetiraj sortiranje',

	filterType: 'Tip',
	filterModificationTime: 'Promijenjeno',
	all: 'Sve',
	today: 'Danas',
	yesterday: 'Jučer',
	pastWeek: 'Prošli tjedan',
	pastMonth: 'Prošli mjesec',
	resetFilters: 'Resetiraj filtere',
	resultLimit: 'Ograničenje rezultata',

	filterSearchPlaceHolder: 'Filtriraj po ključnim riječima',

	resetFilterTag: 'Kliknite X za resetiranje filtera.',
	filterTagToolTip: 'Primijenjeni filteri: %{appliedFilters}.',

	folderName: 'Naziv foldera',
	addAFolder: 'Dodajte folder',
	add: 'Dodaj',
	error: 'Greška',
	newFolderDefaultName: 'Novi folder',
	toastCreateNewFolder: '%{nameOfFolder} folder je kreiran u  %{tabName}.',
	folderAdded: 'Folder je dodan',
	refresh: 'Osvježi',
	openFolder: 'Otvori folder',

	addAUrl: 'Dodajte URL',
	linkName: 'Naziv URL-a',
	linkNamePlaceholder: 'Dodaj naziv URL-a',
	linkDescription: 'Opis (neobavezno)',
	linkDescriptionPlaceholder: 'Dodajte opis',
	linkUri: 'URL',
	linkUriPlaceholder: 'Dodajte URL s prihvatljivom domenom',
	acceptableDomains: 'Prihvatljive domene',
	viewAcceptableDomains: 'Pregled prihvatljivih domena',
	mandatoryField: 'Obavezno polje',
	linkAdded: 'URL je dodan',
	toastCreateNewLink: '%{nameOfLink} je dodana u %{tabName}.',
	noEntries: 'Ne postoje unosi u listi prihvatljivih domena. Kontaktirajte vašeg administratora.',
	unacceptableDomain: 'Vaš URL koristi pogrešnu domenu. Kliknite \'Pregled prihvatljivih domena\' da pogledate listu domena koje možete koristiti.',

	compact: 'Kompaktan',
	short: 'Kratki',
	default: 'Default',
	rowSize: 'Veličina reda',

	// GroupyByTypes
	folders: 'Folderi',
	reports: 'Izvještaji',
	dashboards: 'Kontrolne ploče',
	data: 'Podaci',
	packages: 'Paketi',
	explorations: 'Istraživanja',
	stories: 'Priče',
	notebooks: 'Bilježnice',
	others: 'Ostalo',

	// Error Messages
	itemsOverLimit: 'Navedeni naziv "%{itemName}" premašio je ograničenje maksimalne duljine (20). Molim, navedite različiti naziv da možete nastaviti.',
	errorMessageLengthFolderName: 'Molim, unesite naziv foldera koji ne prelazi 255 znakova.',
	errorMessageLengthLinkName: 'Molim, unesite naziv poveznice koji ne prelazi 255 znakova.',
	toastLaunchPerspectiveError: 'Ne može se otvoriti %{objectType}.',
	errorNoAccessTitle: 'Oh, izgleda da nemate pravo pristupa ovom sadržaju',
	errorNoAccessBody: 'Kontaktirajte svog administratora ili pogledajte sljedeću poveznicu:',
	errorEnableExternalContent: 'Omogućavanje vanjskog sadržaja',

	//TableHeader
	lastAccessed: 'Zadnje dohvaćeno',
	location: 'Lokacija',
	tenant: 'Zakupac',

	// GetStartedTab
	getStartedLabel: 'Kako započeti i raditi u IBM Cognos Analytics',
	learningHowToLabel: 'Resursi za učenje',
	learningHowToDescription: 'Proširite svoje znanje i pronađite pomoć putem povezivanja sa zajednicom, čitanjem dokumentacije i gledanjem video prikaza.',
	learningHowToActionLabel: 'Pokreni okvir za učenje',
	howToVideosLabel: 'Video prikazi \'kako učiniti\'',
	howToVideosDescription: 'Naučite koristiti IBM Cognos Analytics i započnite stjecati uvid u svoje podatke.',
	howToVideosActionLabel: 'Pogledajte video prikaze',
	acceleratorCatalogLabel: 'Accelerator katalog',
	acceleratorCatalogDescription: 'Pregledajte rastući katalog industrijske upotrebe, vodiče za najbolje postupke, prilagođene vizualizacije i više toga.',
	acceleratorCatalogActionLabel: 'Pregled kataloga',
	sampleSectionTitle: 'Primjeri',
	sampleSectionDescription: 'Eksperimentirajte s primjerima koji pokazuje sve što Cognos Analytics može ponuditi.',
	// Samples Section
	createDashboardSampleTitle: 'Kako kreirati prvu kontrolnu ploču',
	createDashboardSampleDescription: 'Započnite svoje putovanje kroz analitiku s Cognos kontrolnim pločama.',
	nlaSampleTitle: 'Primjer izvještaja',
	nlaSampleDescription: 'Istražite što je moguće učiniti s Cognos Analytics izvještajima na ovom primjeru koji  analizira aktivnosti posjednika kartica vjernosti na kraju godine.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Proširite svoju knjižnicu vizualizacija s prilagođenim vizualizacijama poput Sankey grafikona.',
	viewAllSamplesActionLabel: 'Pregled svih primjera',
	byFeatureTitle: 'Po funkciji',
	byFeatureDescription: 'Pregledajte primjere po funkcijama kao što su osnovna funkcionalnost, prilagođene kontrole, proširenja, bilježnice i relativni datumi.',
	byIndustryTitle: 'Po djelatnosti',
	byIndustryDescription: 'Pregledajte primjere po djelatnostima kao što su automobilska industrija, bankarstvo i drugo.',
	// SamplesTab
	sampleTabTitle: 'Koristite predizgrađene primjere za nove ideje',
	sampleTabLabel: 'Posjetite Accelerator katalog za više primjera i proširenja od IBM-a, partnera i korisnika',

	// quickLaunch
	quickLaunchLabel: 'Brzo pokretanje',
	expand: 'Proširi',
	collapse: 'Skupi',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Započnite s izbornom onog što želite kreirati.',

	// contentPageView
	contentPageTitleLabel: 'Sadržaj',
	uploadFile: 'Upload podataka',
	new: 'Novo',
	create: 'Kreiraj',
	more: 'Više',

	// open dialog
	selectDataSourcesToAdd: 'Izaberite izvor(e) podataka koji(e) ćete dodati.',
	openDialogDefaultTitle: 'Otvori',

	// save dialog
	save: 'Spremi',
	saveAs: 'Spremi kao',
	saving: 'Spremanje...',
	selectedDestination: 'Izabrano odredište: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' već postoji kao različiti tip. Molim, izaberite različiti naziv.',
	confirmOverwriteTitle: 'Potvrdi zamjenu postojećih podataka',
	confirmOverwriteMsg: 'Datoteka \'%{nameOfFile}\' već postoji. Želite li zamijeniti njezine podatke s podacima iz izabrane datoteke?',

	// copy move dialog
	copy: 'Kopiraj',
	move: 'Premjesti',
	copyOrMove: 'Kopiraj ili premjesti: ',
	copyOnly: 'Kopiraj ',
	createShortcut: 'Kreiraj prečicu',
	createShortcutDialogTitle: 'Kreiraj prečicu: ',

	// External asset types
	wsProject: 'Watson Studio projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paket',
	dataModule: 'Modul podataka',
	exploration: 'Istraživanje',
	mode: 'Način',
	live: 'Uživo',
	snapshot: 'Snimka',
	noSnapshotsFound: 'Snimka nije nađena',
	uploadedFile: 'Uploadana datoteka',
	fileUpload: 'Upload podataka',
	dataSetEx: 'Skup podataka',
	externalRepository: 'Vanjsko spremište',
	queryMode: 'Način upita',
	queryModeCompatible: 'Kompatibilno',
	queryModeDynamic: 'Dinamički',
	report: 'Izvještaj',
	activeReport: 'Aktivni izvještaj',
	query: 'Upit',
	analysis: 'Analiza',
	dashboard: 'Kontrolna ploča',
	dashboardTemplate: 'Predložak kontrolne ploče',
	jupyterNotebook: 'Bilježnica',
	wsNotebook: 'Watson Studio bilježnica',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Priča',
	workspace: 'Radni prostor',
	pagelet: 'Stranica',
	content: 'Sadržaj',
	directory: 'Imenski prostori',
	dataSet: 'Skup podataka',
	powerPlayCube: 'PowerPlay kocka',
	powerPlayReport: 'PowerPlay izvještaj',
	powerPlay8Report: 'PowerPlay izvještaj',
	setPowerPlay8ReportOptions: 'Postavi opcije PowerPlay izvještaja',
	powerPlay8ReportView: 'PowerPlay pogled izvještaja',
	reportTemplate: 'Predložak izvještaja',
	packageConfigurations: 'Konfiguracija paketa',
	agent: 'Agent',
	agentDefinition: 'Definicija agenta',
	agentDefinitionView: 'Pogled agenta',
	dataMovementTask: 'Zadatak premještanja podataka',
	dataMovementTaskAlias: 'Zamjensko ime zadatka premještanja podataka',
	document: 'Dokument',
	DocumentRetention: 'Svojstva dokumenta',
	jobDefinition: 'Definicija posla',
	job: 'Posao',
	jobs: 'Poslovi',
	metricsDataSourceETLTask: 'Zadatak ETL izvora podataka metrika',
	metricsExportTask: 'Zadatak Eksport metrika',
	metricsFileImportTask: 'Zadatak Import datoteke metrika',
	metricsMaintenanceTask: 'Zadatak Održavanje metrika',
	planningTask: 'Zadatak Planiranje',
	shortcut: 'Prečica',
	shortcuts: 'Prečice',
	URL: 'URL',
	launchable: 'Može se pokrenuti',
	dataSetFolder: 'Folder skupa podataka',
	ViewAccessibleLabel: 'Pregled %{label}',
	overrideReportOptions: 'Nadjačaj default opcije izvještaja',
	formats: 'Formati',
	saveReport: 'Spremi izvještaj',
	reportView: 'Pogled izvještaja',
	reportviews: 'Pogledi izvještaja',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel podaci',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Uloga',
	namespace: 'Imenski prostor',
	namespaceFolder: 'Folder imenskog prostora',
	adminFolder: 'Admin folder',
	//Details
	details: 'Detalji',
	open: 'Otvori',
	created: 'Kreirano',
	modified: 'Promijenjeno',
	owner: 'Vlasnik',
	dataSource: 'Izvor podataka',
	share: 'Dijeli',
	addToFavorites: 'Dodaj u favorite',
	properties: 'Svojstva',
	detailsEmptyStateBody: 'Izaberite stavku da pogledate njene detalje',
	editNameAndDescription: 'Uredi naziv i opis',
	none: 'Nijedan',
	setPdfOptions: 'Postavi PDF opcije',
	runOptions: 'Opcije izvođenja',

	//rename dialog
	nameInvalid: 'Naziv nije ispravan',
	namePlaceholder: 'Unesite naziv',
	description: 'Opis',
	descriptionInvalid: 'Opis ne može biti dulji od 350 znakova.',
	descriptionPlaceholder: 'Unesite opis',
	errorMessageApostropheError: 'Molim, unesite naziv datoteke koja istodobno ne sadrži znakove \' i "',
	renameCollisionError: '%{name} već postoji. Pokušajte s različitim nazivom.',
	unknownRenameError: 'Preimenovanje stavke nije uspjelo. Kontaktirajte administratora za dodatnu pomoć.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Ne može se otvoriti navedeni folder.',

	//Upload
	uploadToFolder: "Uploadaj u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Uploadaj u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> i pokreni %{launchAction}",
	quickUpload: "Brzi upload",
	quickUploadAndLaunch: "Povucite i ispustite datoteke da ih uploadate u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> i otvorite u jednom od sljedećih prostora.",
	unsupportedFilesSingle: "%{files} nije uploadana jer nije važeća za Brzo pokretanje.",
	unsupportedFilesMultiple: "Datoteke nisu uploadane jer sve datoteke koje izaberete moraju biti važeće za korištenje brzog pokretanja.",
	unsupportedFilesSingleInvalid: "%{files} nije važeća.",
	unsupportedFilesMultipleInvalid: "%{files} nisu važeće.",
	supportedFileTypes: "Dozvoljeni su samo sljedeći tipovi datoteka: %{extensions}.",
	uploadDragAndDrop: "Povuci i ispusti",
	uploadDragAndDropMessage: "Povucite i ispustite svoju datoteku ovdje kako biste ju uploadali u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Kriteriji pretraživanja \'%{searchTerm}\' su spremljeni.',
	searchWasntSaved: 'Kriteriji pretraživanja \'%{searchTerm}\' nisu spremljeni.',
	searchSuggestions: 'Prijedlozi',
	savedSearch: 'Spremljena pretraživanja',
	searchWasDeleted: 'Kriteriji pretraživanja \'%{searchTerm}\' su izbrisani.',
	searchWasntDeleted: 'Kriteriji pretraživanja \'%{searchTerm}\' nisu izbrisani.',
	savedBarTitle: 'Pretraži Cognos Analytics',
	searchContentPageTitle: 'Traži',
	searchContentPageTitleLabel: 'Prikaz rezultata za \'%{searchTerm}\'',
	showingSearchRsult: 'Prikaz %{resultCount} stavki',
	saveSearch: 'Spremi pretraživanje',
	saveTenSearches: 'Možete spremiti 10 pretraživanja.',
	deleteASearch: 'Izbrišite jedno da spremite drugo.',
	close: 'Zatvori',
	allContent: 'Sav sadržaj',
	searchResultIn: 'Traži rezultate u: ',
	//recent view
	recents: 'Nedavno',
	noAccessRecent: 'Nema pristupa',
	noAccessRecentMsg: 'Nemate pravo pristupa ovom sredstvu. Možda je onemogućeno ili izbrisano ili su vaše dozvole smanjene. Provjerite stanje sredstva na očekivanoj izvornoj lokaciji. Možete ukloniti sredstvo iz liste nedavnih stavki klikom na OK.',
	noAccessMsg: 'Nemate pravo pristupa ovom sredstvu. Možda je onemogućeno ili izbrisano ili su vaše dozvole smanjene.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} stavki izabrano',
	itemSelected: '%{nameOfSelection} stavka izabrana',

	//properties
	general: 'Općenito',
	schedule: 'Raspored',
	permission: 'Dozvole',
	capabilities: 'Mogućnosti',
	propertiesTabsLabel: 'Sadržaj svojstava',
	searchPath: 'Staza pretraživanja',
	id: 'ID',
	language: 'Jezik',
	setLanguage: 'Postavite jezik',
	entryOptions: 'Opcije unosa',
	setPackage: 'Postavite paket ili modul',
	sourcePackage: 'Izvorni paket ili modul podataka',
	associatedSourceAgent: 'Izvorni paket',
	setAssociatedSourceAgent: 'Postavi paket',
	sourceAgent: 'Agent izvora',
	setSourceAgent: 'Postavi agenta izvornog koda',
	setCapabilities: 'Postavite mogućnosti',
	disableEntry: 'Onemogući ovaj unos',
	hideEntry: 'Sakrij ovaj unos',
	permissions: 'Dozvole',
	promptForValues: 'Prompt za vrijednosti',
	yes: 'Da',
	no: 'Ne',
	setValues: 'Postavite vrijednosti',
	moreOptions: 'Više opcija',
	reportFormat: 'Format izvještaja',
	enableAccessibilitySupport: 'Omogućite podršku pristupačnosti',
	displayOfRunHistory: 'Prikaz povijesti izvođenja',
	occurrences: 'Pojavljivanja',
	days: 'Dan(i)',
	months: 'Mjesec(i)',
	displayOfReportOutputVersions: 'Prikaz izlazne verzije izvještaja',
	defaultDisplayOfPortalAction: 'Zadana akcija portala',
	viewMostRecentReport: 'Pogledajte najnoviji izvještaj',
	runTheReport: 'Pokrenite izvještaj',
	openWithReportStudio: 'Otvori u Report Studiu',
	rowsPerPageInHtmlReports: 'Redovi na stranici HTML izvještaja',
	enableSelectionBasedInteractivity: 'Omogućite interaktivnost putem izbora',
	enableAlertsAboutNewVersions: 'Omogući upozorenja o novim verzijama',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Omogući poboljšane korisničke funkcije u spremljenim verzijama prikaza',
	enableCommentsInSavedOutputVersions: 'Omogući komentare u spremljenim verzijama prikaza',
	run: 'Izvođenje',
	runWithUsersCredentials: 'S korisnikovim vjerodajnicama',
	runWithOwnerCapabilities: 'S mogućnošću vlasnika',
	runAsOwner: 'Kao %{ownerName}',
	actionLabelOn: 'Uključeno',
	actionLabelOff: 'Isključeno',
	openReport: 'Uredi',
	openAnalysis: 'Otvori u Analysis Studiu',
	openQuery: 'Otvori u Query Studiu',
	openPowerPlay8Report: 'Otvori u PowerPlay Studiu',
	openInteractiveReport: 'Uredi',
	read: 'Čitaj',
	write: 'Piši',
	execute: 'Izvedi',
	setPolicy: 'Postavi politiku',
	full: 'Potpuno',
	traverse: 'Proći',
	grant: 'Dodijeli',
	deny: 'Zabrani',
	permissionCustom: 'Prilagođeno',
	permissionDetailsColumnAccess: 'Pristup',
	permissionDetailsColumnPermission: 'Dozvola',
	permissionDetailsColumnAction: 'Akcija',
	permissionSetAccess: 'Postavite pristup',
	permissionRead: 'Čitaj',
	permissionRun: 'Izvedi',
	permissionWrite: 'Piši',
	permissionFull: 'Potpuno',
	unavailable: 'Nije dostupno',
	unkownSource: 'Nepoznat, otvorite izvještaj za detalje',
	tenantSettings: 'Postavke zakupca',
	tenantSet: 'Zakupac ažuriran',
	tenantSetError: 'Greška u postavkama zakupca',
	tenantClear: 'Zakupac izbrisan',
	tenantClearError: 'Greška prilikom brisanja zakupca',
	shortcutTo: 'Prečica za',
	sourceReport: 'Izvorni izvještaj',
	setSourceReport: 'Postavi izvorni izvještaj',
	setSourceLocation: 'Postavi izvornu %{itemName} lokaciju',
	linkPackageOrModule: 'Poveži %{itemName} na paket ili modul podataka',
	linkPackage: 'Poveži %{itemName} na paket',
	externalRepositories: 'Vanjska spremišta',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Vrijeme osvježavanja',
	size: 'Veličina',
	tenantsWarningMessage: 'Promjena zakupca unosa također mijenja zakupca podređenih unosa.',
	confirmClearTenantText: 'Brisanje vrijednosti tako da se postavi \'Ništa\' može drugim zakupcima omogućiti pristup sadržaju. Kliknite OK da biste učinili unos javnim ili Opoziv da biste zadržali trenutnog zakupca.',
	confirmClearTenant: 'Potvrda brisanja zakupca',
	currentValues: 'Trenutne vrijednosti',
	emptyPromptValues: 'Trenutno nema vrijednosti',
	editValues: 'Uredi vrijednosti',
	clear: 'Isprazni',
	source: 'Izvor',
	dataRefreshed: 'Podaci osvježeni',
	//PDF options
	pdfOptions: 'PDF opcije',
	set: 'Skup',
	portrait: 'Portret',
	landscape: 'Pejzaž',
	letter: 'Pismo',
	legal: 'Pravno',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Orijentacija',
	pageDefination: 'Veličina papira',
	openPasswordRequired: 'Potrebna lozinka za otvaranje izvještaja',
	accessPasswordRequired: 'Potrebna lozinka za pristup izvještaju',
	emptyPassword: 'Lozinka ne može biti prazna',
	password: 'Lozinka',
	enterPassword: 'Unesite lozinku',
	confirmPassword: 'Potvrda lozinke',
	passwordMatchError: 'Lozinke se ne podudaraju',
	gateway: 'Gateway',
	pageLayout: 'Izgled stranice',
	pageStyle: 'Stil',
	setUrl: 'Postavi URL',
	numberRows: 'Broj redova',
	numberColumns: 'Broj stupaca',
	timeToRefresh: 'Vrijeme osvježavanja',
	lastRefreshedBy: 'Osvježio',
	unknown: 'Nepoznato',
	unknownUpdateError: 'Ažuriranje stavke nije uspjelo. Kontaktirajte administratora za dodatnu pomoć.',
	editQuery: 'Uređivanje upita',
	greaterOrEqual: 'Veće ili jednako %{upperboundValue}',
	lessOrEqual: 'Manje ili jednako %{lowerboundValue}'
});
